<template>
	<div>
		<div class="md-layout md-gutter">
			<div class="md-layout-item md-size-100">
				<md-card>
					<md-card-header class="md-card-header-icon md-card-header-blue">
						<div class="card-icon">
							<font-awesome-icon class="md-icon" :icon="['fa', 'cubes']" />
						</div>
						<h4 class="title font-normal">Liste des interventions</h4>
					</md-card-header>
					<md-card-content>
						<div class="mb-1">
							<span class="font-bold">Filtres</span>
						</div>
						<div class="flex items-center space-x-8">
							<div class="table-filter">
								<div class="md-multiselect">
									<label>Éléments à afficher</label>
									<multiselect
										v-model="pagination.perPage"
										:options="pagination.perPageOptions"
										placeholder=""
										:show-labels="false"
										@input="getInterventions">
										<template slot="noOptions">La liste est vide</template>
										<template slot="noResult">Aucun élement correspondant</template>
										></multiselect>
								</div>
							</div>
							<div class="table-filter">
								<div class="md-multiselect">
									<label>Année </label>
									<multiselect
										v-model="selectedYear"
										:options="years"
										:option-height="104"
										placeholder=""
										:show-labels="false"
										@input="getInterventions">
										<template slot="noOptions">La liste est vide</template>
										<template slot="noResult">Aucun élement correspondant</template>
										></multiselect>
								</div>
							</div>
						</div>
						<div class="relative" style="min-height: 150px;">
							<md-table class="paginated-table no-actions" :value="interventions" table-header-color="blue">
								<md-table-row v-if="!loading && interventions.length > 0" slot="md-table-row" slot-scope="{ item }">
									<md-table-cell md-label="Date">
										<span class="text-info font-medium">{{ getStartDate(item.planningable.start_date) }}</span>
									</md-table-cell>
									<md-table-cell md-label="Type" style="min-width: 350px;">
										<div class="flex flex-col">
											<span class="font-medium">{{ item.intervention_type ?  item.intervention_type.name : '' }}</span>
											<span class="text-xs">{{ getInterventionType(item) }}</span>
										</div>
									</md-table-cell>
									<md-table-cell md-label="Site" style="min-width: 500px;">
										<div>
											{{ getSiteName(item) }}
										</div>
									</md-table-cell>
									<md-table-cell md-label="Documents">
										<div class="flex justify-end align-center">
											<div style="width: auto; min-width: 44px;">
                                                <div v-if="item.documents.length > 0">
                                                    <md-button class="md-icon-button md-raised md-info" @click="openDrawer(item)">
                                                        <font-awesome-icon class="md-icon" :icon="['fa', 'file']" />
                                                    </md-button>
                                                    <md-tooltip md-direction="top">Voir les documents annexes</md-tooltip>
                                                </div>
											</div>
                                            <div style="width: auto; min-width: 44px;">
                                                <div v-if="!isAudit && item.report && item.report.url">
                                                    <md-button class="md-icon-button md-raised md-danger" @click="getPdfReport(item.report.url)">
                                                        <font-awesome-icon class="md-icon" :icon="['fa', 'file-pdf']" />
                                                    </md-button>
                                                    <md-tooltip md-direction="top">Télécharger le rapport</md-tooltip>
                                                </div>
                                            </div>
										</div>
									</md-table-cell>
								</md-table-row>
								<md-table-empty-state v-if="!loading"
								                      md-label="Pas d'interventions trouvées"
								                      md-description="Essayez une recherche différente">
								</md-table-empty-state>
							</md-table>
							<div v-if="loading" class="loader-overlay opacity-100 absolute z-50 w-full h-full">
								<div class="h-full w-full flex items-center justify-center">
									<md-progress-spinner class="md-white" md-mode="indeterminate"
									                     :md-diameter="50" :md-stroke="4"></md-progress-spinner>
								</div>
							</div>
						</div>
					</md-card-content>
					<md-card-actions md-alignment="space-between"  v-if="this.interventions.length > 0">
						<p class="card-category">
							Affichage des éléments {{ from + 1 }} à {{ to }} sur {{ pagination.total }} éléments
						</p>
						<pagination
							class="pagination-no-border pagination-info"
							v-model="pagination.currentPage"
							:per-page="pagination.perPage"
							:total="pagination.total"
							@input="getInterventions"
						>
						</pagination>
					</md-card-actions>
				</md-card>
			</div>
		</div>
		<md-drawer class="drawer-form" md-right md-fixed :md-active.sync="showPanel">
			<div class="px-3" v-if="selectedIntervention">
				<div>
					<h4 class="font-medium text-primary text-base mb-1">Détails de l'intervention</h4>
					<h4 class="text-sm"><span class="font-medium">Date : </span> {{ getStartDate(selectedIntervention.planningable.start_date)}}</h4>
					<h4 class="text-sm"><span class="font-medium">Type : </span> {{ selectedIntervention.intervention_type.name }}</h4>
					<h4 class="text-sm"><span class="font-medium">Site : </span> {{ getSiteName(selectedIntervention) }}</h4>
				</div>
				<md-divider class="mt-2.5 mb-2"></md-divider>
				<h4 class="font-medium text-sm">Liste des documents annexes</h4>
				<ul class="list-files mt-1">
					<li v-for="(document, key) in selectedIntervention.documents" :key="key">
						<div class="flex items-center mb-2">
							<font-awesome-icon class="md-icon" :icon="['fa', 'file']" />
							<a :href="document.url" class="file-name text-sm">{{ document.name }}</a>
						</div>
					</li>
				</ul>
			</div>
		</md-drawer>
	</div>
</template>

<script>
import { Pagination } from "../../index";
export default {
	name: "ListInterventionsTable",
	components: {
		Pagination
	},
	props: {
		isAudit: {
			type: Boolean,
			default() {
				return false
			}
		}
	},
	data() {
		return {
			interventions: [],
			pagination: {
				perPage: 50,
				currentPage: 1,
				perPageOptions: [10, 25, 50, 100],
				total: 0
			},
			selectedYear: this.$moment(new Date()).format('YYYY'),
			searchedData: [],
			loading: true,
			showPanel: false,
			selectedIntervention: null
		}
	},
	computed: {
		to() {
			let highBound = this.from + this.pagination.perPage;
			if (this.pagination.total < highBound) {
				highBound = this.pagination.total;
			}
			return highBound;
		},
		from() {
			return this.pagination.perPage * (this.pagination.currentPage - 1);
		},
		total() {
			return this.searchedData.length > 0
				? this.searchedData.length
				: this.interventions.length;
		},
		years () {
			let firstYear = this.$moment('2015-01-01').year()
			let currentYear = this.$moment().year()
			let years = []
			let year = firstYear
			while (year <= currentYear) {
				years.push(year.toString())
				year++
			}
			return years
		}
	},
	methods: {
		getPdfReport (url) {
			let link = document.createElement('a')
			link.setAttribute('href', url)
			link.setAttribute('target', '_blank')
			link.click()
		},
		openDrawer (intervention) {
			this.showPanel = true
			this.selectedIntervention = intervention
		},
		async getInterventions() {
			this.loading = true
			const localStorageData = JSON.parse(localStorage.getItem('client-area'))

			const response = await this.$store.dispatch('clientArea/fetchInterventions', {
				access_token: localStorageData.accessToken,
				user_type: localStorageData.userType,
				page: this.pagination.currentPage,
				perPage: this.pagination.perPage,
				search: this.selectedYear,
				isAudit: this.isAudit
			})

			this.interventions = response.data.data
			this.pagination.total = response.data.total
			this.loading = false
		},
		getInterventionType(intervention) {
			let type = 'Contrat'
			if(!intervention.planning_intervention_prevision_id) {
				type = 'Ponctuel contrat'
				if(!intervention.contract_id) {
					if (intervention.category_id === 2) {
						type = 'Intervention sous garantie'
					} else if (intervention.category_id === 4) {
						type = 'Ponctuel site'
					} else if (intervention.category_id === 5) {
						type = 'Support'
					} else if (intervention.category_id === 6) {
						type = 'Formation'
					}
				}
			}
			return type
		},
		getStartDate(date) {
			return this.$moment(date).format('DD/MM/YYYY')
		},
		getSiteName(intervention) {
			return intervention.site ? intervention.site.name : (intervention.contract ? intervention.contract.site.name : (intervention.planning_intervention_prevision.planning_intervention_group.planning_intervention.contract.site.name))
		}
	},
	mounted() {
		this.getInterventions()
	}
}
</script>

<style scoped>

</style>
